"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _useDetectSticky2 = _interopRequireDefault(require("../common/useDetectSticky"));
var _HBTableColumnHeaders = _interopRequireDefault(require("./HBTableColumnHeaders"));
var _HBTableFilters = _interopRequireDefault(require("./HBTableFilters"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBTable = require("./HBTable.styles");
function HBTableHeader(_ref) {
  var table = _ref.table,
    tableBodyEl = _ref.tableBodyEl;
  var _useDetectSticky = (0, _useDetectSticky2["default"])(),
    setEl = _useDetectSticky.setEl,
    isStuck = _useDetectSticky.isStuck;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    ref: setEl,
    $isStuck: isStuck
  }, /*#__PURE__*/_react["default"].createElement(_HBTableFilters["default"], {
    table: table
  }), /*#__PURE__*/_react["default"].createElement(_HBTableColumnHeaders["default"], {
    table: table,
    tableBodyEl: tableBodyEl
  }));
}
var _default = exports["default"] = HBTableHeader; // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTableHeader__Container",
  componentId: "sc-fo9pae-0"
})(["position:sticky;top:0;z-index:", ";border-top-left-radius:inherit;border-top-right-radius:inherit;", ""], _HBTable.TABLE_Z_INDEX.TOP, function (_ref2) {
  var $isStuck = _ref2.$isStuck;
  return (0, _HBTable.scrollShadow)({
    isShadowActive: $isStuck,
    size: 12,
    direction: 'bottom'
  });
});
//# sourceMappingURL=HBTableHeader.js.map